// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_VgB","cls2":"FullScreenPremiumModal-cls2_850 FullScreenPremiumModal-cls1_VgB"};